<template>
  <div class="register">
    <div class="login-wrapper">
      <div class="r con-wrap">
        <p class="tit">注册新账号</p>
        <input type="text" placeholder="邮箱" v-model="email">
        <input type="password" placeholder="密码" v-model="password">
        <input type="text" placeholder="手机号" v-model="telphone">
        <div class="yz clearfix">
          <input type="text" class="yz-inp" placeholder="验证码" v-model="code">
          <div class="sent" @click="sendyzm">{{sendMsg}}</div>
        </div>
        <div class="jtocode" v-show="codeshow"></div>
        <div class="wrong" v-show="errorShow">{{errorMsg}}</div>
        <div class="read">
          <span>
            <label for="sel">
              <input type="checkbox" name="" id="sel" v-model="onoff">
              <span class="selbox" :class="onoff ? 'active' : ''" ></span>阅读并同意
            </label>
            <span class="col" @click.stop="alertFn">《图灵用户协议》</span>
          </span>
        </div>
        <div class="login-btn" @click="submit">注册</div>
      </div>
    </div>
    <agreement v-on:close="close" :alertshow="alertshow" v-on:agree="agree" v-on:unagree="unagree"></agreement>
    <successalert :show="show" :msg="msg"></successalert>
  </div>
</template>

<script>
  import agreement from '../agreement/agreement.vue';
  import successalert from '../successalert/successalert.vue';
  import '../../js/geetest.js';
  import $ from 'jquery';
  import mixin from '../../js/public.js';

  export default{
    mixins: [mixin],
    data () {
        return {
          show: false,
          errorShow: false,
          errorMsg: '',
          email: '',
          password: '',
          telphone: '',
          code: '',
          id: '',
          codeshow: false,
          sendMsg: '发送验证码',
          onoff: true,
          alertshow: false,
          msg: '恭喜你，注册成功！',
          type: ''
        };
      },
      created () {
        var _this = this;
        this.id = this.uuid();
        this.type = this.getUrlFn('type');
        $.ajax({
          url: _this.baseUrl + '/geetest/v3',
          type: 'POST',
          dataType: 'json',
          data: {id: _this.id},
          xhrFields: {
            withCredentials: true
          },
          success: function (res) {
            if (res.type === 'success') {
              window.initGeetest({
                gt: res.data.gt,
                challenge: res.data.challenge,
                new_captcha: res.data.new_captcha,
                product: 'popup',
                width: '100%',
                offline: !res.data.success
              }, _this.handlerPopup);
            }
          }
        });
      },
      components: {
        agreement,
        successalert
      },
      methods: {
        agree () {
          this.onoff = true;
          this.alertshow = false;
        },
        unagree () {
          this.onoff = false;
          this.alertshow = false;
        },
        close () {
          this.alertshow = false;
        },
        alertFn () {
          this.alertshow = true;
        },
        uuid () {
          function S4 () {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
          }
          return (S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4());
        },
        handlerPopup (captchaObj) {
          var _this = this;
          captchaObj.appendTo('.jtocode');
          captchaObj.onSuccess(function () {
            var validate = captchaObj.getValidate();
            setTimeout(function () {
              _this.codeshow = false;
            }, 1500);
            _this.$http.post(_this.baseUrl + '/common/exist-user', {u: _this.telphone}).then(function (res) {
              if (res.body.type === 'success') {
                if (res.body.data) {
                  _this.errorMsg = '该手机号已经注册';
                  _this.errorShow = true;
                  captchaObj.reset();
                } else {
                  $.ajax({
                    url: _this.baseUrl + '/register/send/4',
                    type: 'POST',
                    dataType: 'json',
                    data: {geetest_challenge: validate.geetest_challenge, geetest_validate: validate.geetest_validate, geetest_seccode: validate.geetest_seccode, mobile: _this.telphone},
                    xhrFields: {
                      withCredentials: true
                    },
                    success: function (data) {
                      if (data.type === 'success') {
                        _this.toCode();
                        captchaObj.reset();
                      } else {
                        _this.errorMsg = '操作频繁，请稍后再试';
                        _this.errorShow = true;
                      }
                    }
                  });
                }
              }
            }, function () {
              _this.errorMsg = '网络错误，请稍后重试';
              _this.errorShow = true;
            });

          });
        },
        toCode () {
          var _this = this;
          var i = 60;
          this.sendMsg = i + '秒';
            var nu = setInterval(function () {
              i--;
              _this.sendMsg = i + '秒';
              if (i === 0) {
                clearInterval(nu);
                _this.sendMsg = '发送验证码';
              }
            }, 1000);
        },
        sendyzm () {
          var phonetest = /^1[0-9]{10}$/;
          if (this.sendMsg.length !== 5) {
            return;
          }
          if (!phonetest.test(this.telphone)) {
            this.errorMsg = '请输入正确的手机号码';
            this.errorShow = true;
            return;
          }
          this.errorShow = false;
          this.codeshow = true;
        },
        submit () {
          var _this = this;
          var phonetest = /^1[0-9]{10}$/;
          var emailtest = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
          var re = /^\d+$/;
          var re1 = /^[a-zA-Z]+$/;
          var re2 = /^[`~!@#\$%\^&\*\(\)_\+<>\?:"\{\},\.\\\/;'\[\]！。；、’“”]+$/;
          var val = this.password;
          var len = val.length;
          if (!this.onoff) {
            this.errorMsg = '请阅读并同意 《图灵用户协议》';
            this.errorShow = true;
            return;
          }
          if (!emailtest.test(this.email)) {
            this.errorMsg = '请输入正确邮箱格式';
            this.errorShow = true;
            return;
          }
          if (!phonetest.test(this.telphone)) {
            this.errorMsg = '请输入正确的手机号码';
            this.errorShow = true;
            return;
          }
          if (re.test(val) || re1.test(val) || re2.test(val) || len > 16 || len < 6) {
            this.errorMsg = '密码需要6-16位，且必须包含两种以上字符';
            this.errorShow = true;
            return;
          }
          if (!this.code) {
            this.errorMsg = '验证码不能为空';
            this.errorShow = true;
            return;
          }
          this.errorShow = false;
          /* 判断邮箱是否已经注册 */
          this.$http.post(_this.baseUrl + '/common/exist-user', {u: _this.email}, {credentials: true}).then(function (res) {
            if (res.body.type === 'success') {
              if (res.body.data === true) {
                _this.errorMsg = '该邮箱已经注册';
                _this.errorShow = true;
              } else {
                /* 判断手机是否已经注册 */
                _this.$http.post(_this.baseUrl + '/common/exist-user', {u: _this.telphone}, {credentials: true}).then(function (res) {
                  if (res.body.type === 'success') {
                    if (res.body.data === true) {
                      _this.errorMsg = '该手机已经注册';
                      _this.errorShow = true;
                    } else {
                      /* 判断手机号、验证码是否正确 */
                      _this.$http.post(_this.baseUrl + '/register/validate/1', {mobile: _this.telphone, code: _this.code}, {credentials: true}).then(function (res) {
                        if (res.body.type === 'success') {
                          /* 提交信息 */
                          var url = _this.type === 'others' ? _this.baseUrl + '/register/save/3' : _this.baseUrl + '/register/save/4';
                          _this.$http.post(url, {
                            email: _this.email,
                            mobile: _this.telphone,
                            code: _this.code,
                            password: _this.password,
                            auto_login: true,
                            redirect_uri: '',
                            referer: _this.ReturnURl
                          }, {credentials: true}).then(function (res) {
                            if (res.body.type === 'success') {
                              _this.show = true;
                              window.location = _this.ReturnURl;
                            } else {
                              _this.errorMsg = '验证码错误';
                              _this.errorShow = true;
                            }
                          }, function () {
                            _this.errorMsg = '网络错误，请稍后重试';
                            _this.errorShow = true;
                          });
                        } else {
                          _this.errorMsg = '验证码错误';
                          _this.errorShow = true;
                        }
                      }, function () {
                        _this.errorMsg = '网络错误，请稍后重试';
                        _this.errorShow = true;
                      });
                    }
                  }
                }, function () {
                  _this.errorMsg = '网络错误，请稍后重试';
                  _this.errorShow = true;
                });
              }
            }
          }, function () {
            _this.errorMsg = '网络错误，请稍后重试';
            _this.errorShow = true;
          });
        }
      }
    };
</script>

<style lang="scss" scoped="" type="text/css">
  @import '../../css/public.scss';

</style>



// WEBPACK FOOTER //
// register.vue?983a3c7e